import { Modal } from "react-bootstrap";
import { Button, IconButton, ProfileDisplay } from "../../../components";
import { FormCheck } from "../../../components/forms";
import { GenericUserSelect } from "../../../components/forms/selects";
import { Spinner } from "../../../components/loaders";
import useClientSetPermissions from "../hooks/useClientSetPermissions";
import ThemedModal from "../../../components/utilities/ThemedModal";

const ClientSetPermissionRow = ({ row, editRow }) => (
    <tr>
        <td><ProfileDisplay userId={row.userId} /></td>
        <td>
            <FormCheck
                groupClassName="mx-auto"
                isChecked={row.canRead}
                onChange={() => editRow('canRead', !row.canRead)}
                disabled={row.isDisabled} />
        </td>
        <td>
            <FormCheck
                groupClassName="mx-auto"
                isChecked={row.canWrite}
                onChange={() => editRow('canWrite', !row.canWrite)}
                disabled={row.isDisabled} />
        </td>
        <td />
    </tr>
);

const ClientSetUserSelectModal = ({ defaultValue, onChange, addRow, ...modalProps }) => {
    const { onHide } = modalProps;

    return <Modal centered onHide={onChange} size="sm" backdrop="static" {...modalProps}>
        <ThemedModal.Header closeButton>
            <Modal.Title>Select User</Modal.Title>
        </ThemedModal.Header>
        <Modal.Body>
            <GenericUserSelect
                defaultValue={defaultValue}
                onChange={(selection) => onChange(selection.value)}
                disableAnimations
            />
        </Modal.Body>
        <Modal.Footer>
            <Button variant="success" onClick={addRow}>
                Add User
            </Button>
            <Button variant="light" onClick={onHide}>
                Cancel
            </Button>
        </Modal.Footer>
    </Modal>
}

const ClientSetPermissionsModal = ({ onHide, ...modalProps }) => {
    const {
        accessList,
        isFetching,
        showUserSelect,
        setShowUserSelect,
        addUserId,
        setAddUserId,
        addUser,
        updateUser
    } = useClientSetPermissions();

    return <>
        <ClientSetUserSelectModal
            defaultValue={addUserId}
            onChange={(userId) => setAddUserId(userId)}
            addRow={addUser}
            show={showUserSelect}
            onHide={() => setShowUserSelect(false)}
        />
        <Modal centered onHide={onHide} size="lg" backdrop="static" {...modalProps}>
            <ThemedModal.Header closeButton>
                <Modal.Title>Client Set Permissions</Modal.Title>
            </ThemedModal.Header>
            <Modal.Body>
                {isFetching
                    ? <Spinner />
                    : <div className="table-responsive">
                        <table className="table table-striped table-hover">
                            <thead>
                                <tr>
                                    <th>User</th>
                                    <th>Read</th>
                                    <th>Edit</th>
                                    <th style={{ width: "0" }}>
                                        <IconButton
                                            variant="success"
                                            icon="plus"
                                            onClick={() => setShowUserSelect(true)}
                                        />
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {accessList?.map((row) => (
                                    <ClientSetPermissionRow
                                        key={row.userId}
                                        row={row}
                                        editRow={(field, value) => updateUser({
                                            userId: row.userId,
                                            [field]: value
                                        })}
                                    />
                                ))}
                            </tbody>
                        </table>
                    </div>}
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={onHide}>
                    Close
                </Button>
            </Modal.Footer>
        </Modal>
    </>
}

export default ClientSetPermissionsModal;